var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"initial-reservation-item",style:(_vm.styles),attrs:{"data-e2e":"initial-reservation-item"},on:{"click":_vm.displayReservation}},[_vm._v(" 〇 ")])}
var staticRenderFns = []

export { render, staticRenderFns }